import { useLocale } from '~/hooks/useLocale';
import { formatMoney } from '~/i18n';
import { CountryCode, getCurrencyByCountryCode } from '~/locales';

interface ReviewCostProps {
  cost: number;
  className?: string;
  countryCode?: string;
}

export const ReviewCost = ({ cost, countryCode, className = '' }: ReviewCostProps) => {
  const { currentLocale } = useLocale();

  const currency = countryCode ? getCurrencyByCountryCode(countryCode as CountryCode) : currentLocale.currency;

  return (
    <div className={`text-sm font-bold bg-background text-primary px-2 py-1 rounded-md border border-primary-500 ${className}`}>
      {formatMoney(cost ?? 0, currentLocale, currency)}
    </div>
  );
}; 